import { ssrModel } from "src/models/ssr"
import { userModel } from 'src/common/razzle-platform-user/model'
import { translationModel } from 'src/common/razzle-platform-translate/model'


export type RootModel = any

export const models: RootModel = {
    ssrModel,
    userModel,
    translationModel
}
